export class Answer {
  id: number;
  text: string;
  correct?: boolean;
  selected: boolean;
  players?: Array<any>;
}
